import * as React from "react";
//import * as data from './data';
//import { Link } from 'react-router-dom';
//import { SGFs } from './SGFs';
import { Account } from "Account";

export function Home(): JSX.Element {
    return <Account />;
}
